import LogsReportProjectInfo from "./LogsReportProjectInfo";

const presentRow = (row) => !_.every(row, _.isEmpty);

export default function PushPierLogReportPage({page, project}) {
  const firstPage = page.pageNumber === 1;

  return <>
    {firstPage && <LogsReportProjectInfo project={project}/>}

    <div className="grid">
      {page.piles.map((pile) => (
        <div key={pile.pileNo} className="col-1-2">
          <table className="report-table push-pier">
            <tbody>
              <tr>
                <th colSpan={4} className="row-header">Pier No. {pile.pileNo}</th>
              </tr>
              <tr>
                <th>Time</th>
                <th>Depth (ft)</th>
                <th>Pressure (psi)</th>
                <th>Load (lbs)</th>
              </tr>
              {pile.measurements?.map((row, i) => presentRow(row) && (
                <tr key={i}>
                  <td>{row[0]}</td>
                  <td>{row[1]}</td>
                  <td>{row[2]}</td>
                  <td>{row[3]}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <h4>Proof Test Values:</h4>
          <table className="report-table push-pier">
            <tbody>
              <tr>
                <th>Proof Test Pressure (psi)</th>
                <td>{pile.proofTestPressure}</td>
              </tr>
              <tr>
                <th>Proof Test Load (kips)</th>
                <td>{pile.proofTestLoad}</td>
              </tr>
              <tr>
                <th>Hold Duration</th>
                <td>{pile.holdDuration}</td>
              </tr>
              <tr>
                <th>Creep &lt; 1/16 in/hr</th>
                <td>{pile.creep}</td>
              </tr>
            </tbody>
          </table>

          <h4>Final Install Values:</h4>
          <table className="report-table push-pier">
            <tbody>
              <tr>
                <th>Depth (ft)</th>
                <td>{pile.finalDepth}</td>
              </tr>
              <tr>
                <th>Applied Load</th>
                <td>{pile.appliedLoad}</td>
              </tr>
              <tr>
                <th>Design Load</th>
                <td>{pile.designLoad}</td>
              </tr>
              <tr>
                <th>Install Rate</th>
                <td>{pile.installRate}</td>
              </tr>
            </tbody>
          </table>
        </div>
      ))}
    </div>
  </>;
}
